import { QueovalBase, QueovalDate } from "../global";
import { Select } from "../utilities";
import { Corporation } from "./action-co.model";

export class ActionCoDevisModel extends QueovalBase {

  public ActionCo: ActionCoActionCo;
  public Project: ActionCoProject;
  public Devis: ActionCoDevis;

  public ListEntiteFacturation: Array<ActionCoEntiteGroupFacturation>;
  public ListTypeDoc: Array<Select>;
  public ListDossierDevis: Array<Select>;

  public PersonneMorale: Corporation;
  //public PersonneMorale: Select;
  //public TypePersonneMorale: string;

  public ListContact: Array<ActionCoContact>;
  public ListContactPrincipal: Array<ActionCoContact>;
  public ListTypeRemise: Array<Select>;
  public ListUnite: Array<Select>;
  public ListTauxTVA: Array<Select>;
  public ListGroupOption: Array<Select>;
  public ListMotif: Array<Select>;
  public ListTypeStage: Array<Select>;
  public ListTypeTarif: Array<Select>;
  public ListCyclesStage: Array<Select>;

  public ActionCoFormation: Array<ActionCoFormation>;
  public ActionCoTypeFormation: Array<ActionCoTypeFormation>;
  public ListTypeFormation: Array<Select>;
  public ListColonneFormation: Array<Select>;

  public ListArticle: Array<Select>;

  public ListActionCoLigneDevisOption: Array<ActionCoLigneDevisOption>;

  public CRUDActionCoLigneDevis: ActionCoLigneDevis;

  public ListActionCoParcours: Array<ActionCoParcours>;
  public SelectedTarif: string;
  public IsStageActif: boolean;


  constructor() {
    super();
    this.ActionCo = new ActionCoActionCo();
    this.Project = new ActionCoProject();
    this.Devis = new ActionCoDevis();
    this.ActionCoFormation = new Array<ActionCoFormation>();
  }
}


export class ActionCoActionCo {
  public Ident: string;
  public Commentaire: string;
  public Motif: Select;
  public TypeDevis: Select;
  constructor() {
    this.Ident = '';
    this.Commentaire = '';
    this.Motif = new Select();
  }
}

export class ActionCoProject {
  public ident: string;
  public Value: string;
  public entite: Select;
  public group: Select;
  public ListDevis: Array<Select>;
}

export class ActionCoDevis {
  public StateDevis: CRUD;
  public Ident: string;

  public IdCommercial: string;
  public PhotoCommercial: string;
  public NameCommercial: string;

  public Titre: string;
  public Info: string;
  public Commentaire: string;
  public Reference: string;
  public Numero: string;
  public TypeDoc: Select;
  public Dossier: Select;
  public Date: QueovalDate;
  public FileExist: boolean;

  public ReadOnly: boolean;
  public DevisPerdu: boolean;
  public DatePerdu: QueovalDate;
  public DevisSigne: boolean;
  public DateSignature: QueovalDate;
  public IdTransactionESign: string;
  public StateESign: ESIGNSTATE;

  public MontantRemiseHT: number;
  public MontantRemiseTTC: number;
  public MontantRemiseTVA: number;


  public MontantHT: number;
  public MontantTTC: number;
  public MontantTVA: number;

  public MontantHTAvantRemise: number;
  public MontantTTCAvantRemise: number;
  public MontantTVAAvantRemise: number;

  public MontantAcompte: number;

  public DureeHeure: number;
  public DureeJour: number;
}

export class ActionCoLigneDevis {
  public StateLigne: CRUD;
  public Ident: string;
  public Designation: string;
  public Information: string;
  public OrdreLigne: number;

  public IdentFormation: string;
  public IdentAction: string;
  public SessionStage: ActionCoSessionStage;
  //public IdentSession: string;
  //public IdentStage: string;
  //public IdentEvenement: string;
  public IdentGroupOption: string;

  public GroupOption: Select;
  public Article: ActionCoArticleFacturation;
  public Quantite: number;
  public PrixUnitaire: number;
  public Remise: number;
  //public RemiseEditable: boolean;

  public TypeRemise: Select;
  public Unite: Select;
  public TauxTVA: Select;

  public MontantRemiseHT: number;
  public MontantRemiseTTC: number;
  public MontantRemiseTVA: number;

  public MontantHT: number;
  public MontantTTC: number;
  public MontantTVA: number;

  public MontantHTAvantRemise: number;
  public MontantTTCAvantRemise: number;
  public MontantTVAAvantRemise: number;

  public DureeHeure: number;
  public DureeJour: number;

  //Varible front
  public IntituleAction: string;
  public IntituleSession: string;



  constructor() {
    this.Article = new ActionCoArticleFacturation();
    this.TypeRemise = new Select();
    this.Unite = new Select();
    this.TauxTVA = new Select();
    this.GroupOption = new Select();
    this.SessionStage = new ActionCoSessionStage();
  }
}

export class ActionCoTypeFormation {
  public Type: Select;
  public ColonneFormation: Array<ActionCoColonneFormation>;
}

export class ActionCoColonneFormation {
  public Colonne: Select;
  public Formation: Array<ActionCoFormation>;
}

export class ActionCoFormation {
  public Ident: string;
  public TypeFormation: Select;
  public ColonneFormation: Select;
  public Intitule: string;
  public Designation: string;
  public ListAction: Array<ActionCoAction>;
}

export class ActionCoAction {
  public Ident: string;
  public Intitule: string;
  public Description: string;
  public Code: string;

  public Quantite: number;
  public PrixUnitaire: number;
  public Unite: Select;
  public Article: ActionCoArticleFacturation;
  public TauxTVA: Select;
  public GroupOption: Select;
  public InfoInterne: string;
  public DureeHeure: number;
  public DureeJour: number;
  public ListSessionStage: Array<ActionCoSessionStage>;
}

export class ActionCoSessionStage {
  public Ident: string = '0';
  public Intitule: string;
  public Type: Select;
  public IdentSession: string;
  public IdentStage: string;
  public IdentEvenement: string;
  public Information: string;
  public DateDebut: QueovalDate;
  public DateFin: QueovalDate;
}

export class ActionCoContact extends Select {
  public selected: boolean;
}

export class ActionCoEntiteGroupFacturation extends Select {
  public ListGroupFacturation: Array<ActionCoGroupFacturation>;

}


export class ActionCoGroupFacturation extends Select {
  public ListArticle: Array<ActionCoArticleFacturation>;
}

export class ActionCoArticleFacturation extends Select {
  public tauxTVA: Select;
  public title: string;
  public isBareme: boolean;
}

export class ActionCoParcours {
  public IdCatalogue: string;
  public IdAction: string;
  public IdStage: string;
  public TypeStage: string;
  public IdReservation: string;
  public PrixUnitaire: number;
  public Quantite: number;
}

export class ActionCoLigneDevisOption {
  public Ident: string;
  public CodeOption: string;
  public InfoOption: string;
  public OrderOption: number;

  public MontantRemiseHT: number;
  public MontantRemiseTTC: number;
  public MontantRemiseTVA: number;

  public MontantHT: number;
  public MontantTTC: number;
  public MontantTVA: number;

  public MontantHTAvantRemise: number;
  public MontantTTCAvantRemise: number;
  public MontantTVAAvantRemise: number;

  public ListActionCoLigneDevis: Array<ActionCoLigneDevis>;
}


export class ActionCoFormationList extends Select {

  public FormationList: Array<ActionCoFormation>;
}

export enum CRUD {
  CREATE,
  READ,
  UPDATE,
  DELETE
}


export enum ESIGNSTATE {
  INACTIF,
  WAITING,
  READY,
  INPROGRESS,
  ENDED
}
